import * as ACTIONS from '@/store/constants/actions.js';
import * as GETTERS from '@/store/constants/getters.js';
import * as MUTATIONS from '@/store/constants/mutations.js';
import { requestPage } from '@/resources/page.js';

export const actions = {
    [ACTIONS.FETCH_PAGE_BY_UUID]({ getters, commit }, { page_uuid, site_uuid }) {
        if (getters[GETTERS.PAGE_BY_UUID](page_uuid)) {
            return Promise.resolve();
        }

        commit(MUTATIONS.SET_PAGE, {
            key: page_uuid,
            item: {},
        });
        return requestPage(page_uuid, site_uuid)
            .then((page) => commit(MUTATIONS.SET_PAGE, {
                key: page_uuid,
                item: page,
            }));
    },
};
